import { UA } from './ua';

export const LANG_TRANSLATION = {
  UA,
};
